import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MovementManagerComponent} from './movement-manager.component';
import {
  MovementManagerInsertModeComponent
} from './movement-manager-insert-mode/movement-manager-insert-mode.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatLegacyButtonModule} from "@angular/material/legacy-button";
import {MatIconModule} from "@angular/material/icon";
import {CtButtonModule, CtFrameworkModule, FormatModule} from "@ctsolution/ct-framework";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MovementManagerRowsComponent} from './movement-manager-rows/movement-manager-rows.component';
import {TableModule} from "primeng/table";
import {MatLegacyCardModule} from "@angular/material/legacy-card";
import {MovementManagerAddItemModule} from "./movement-manager-add-item/movement-manager-add-item.module";
import {MatLegacyRadioModule} from "@angular/material/legacy-radio";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {DropdownModule} from "primeng/dropdown";
import {TagModule} from "primeng/tag";
import { MovementManagerAddOfferModule } from './movement-manager-add-offer/movement-manager-add-offer.module';
import { CheckboxModule } from 'primeng/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MovementManagerDescriptionDialogModule } from './movement-manager-description-dialog/movement-manager-description-dialog.module';

@NgModule({
  declarations: [
    MovementManagerComponent,
    MovementManagerInsertModeComponent,
    MovementManagerRowsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatLegacyButtonModule,
    MatIconModule,
    CtFrameworkModule,
    FlexLayoutModule,
    TableModule,
    MatLegacyCardModule,
    MovementManagerAddItemModule,
    MovementManagerAddOfferModule,
    MatLegacyRadioModule,
    ButtonModule,
    RippleModule,
    CtButtonModule,
    DropdownModule,
    FormsModule,
    TagModule,
    FormatModule,
    CheckboxModule,
    MatTooltipModule,
    MovementManagerDescriptionDialogModule
  ],
  exports: [MovementManagerComponent]
})
export class MovementManagerModule {
}
